// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".v-stepper[data-v-1da1729a]{background:transparent}.v-alert[data-v-1da1729a]  h2:first-of-type{line-height:100%;margin-bottom:25px}.v-alert[data-v-1da1729a]  p{color:#000}", ""]);
// Exports
module.exports = exports;
